import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=566ed8be&scoped=true&"
import script from "./TabButton.vue?vue&type=script&lang=ts&"
export * from "./TabButton.vue?vue&type=script&lang=ts&"
import style0 from "./TabButton.vue?vue&type=style&index=0&id=566ed8be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ed8be",
  null
  
)

export default component.exports